import React, { useMemo } from 'react';
import Select from 'react-select';
import RichTextBox from '../../../../../customControl/RichTextBox';
import FlightInclusion from './components/FlightInclusion';
import TransferInclusion from './components/TransferInclusion';
import AirportTransferInclusion from './components/AirportTransferInclusion';
import HotelInclusion from './components/HotelInclusion';
import SightseeingInclusion from './components/SightseeingInclusion';
import AttractionInclusion from './components/AttractionInclusion';
import ItineraryTable from './components/ItineraryTable';

const DayScheduleAccordion = ({
    Shown,
    formerror,
    formvalue,
    disabled,
    onChange,
    sightseeinglistdata,
    handleDaysightseeing,
    dayscheduleconfig,
    setEditorRef,
    inclusionwithshortnamelist,
    handleinclusionnamechange,
    // Flight
    flightvisible,
    flightfrom,
    flightfromid,
    handleFlightFromchange,
    fromflightdisable,
    flightto,
    flighttoid,
    handleFlightToChange,
    toflightdisable,
    flightopen,
    handleFlight,
    airlinelist,
    airlineid,
    handleAirlineChange,
    flightnolist,
    flightno,
    handleFlightNoChange,
    arrivalTime,
    handleonchangeofTime,
    departureTime,
    airlineclasslist,
    classid,
    handleclasschange,
    supplierlist,
    supplierid,
    handlesupplierchange,
    // Transfers
    EnableTransferSightseeingInclusionIds,
    transfersightseeinglistdata,
    transferSightseeingDetail,
    handletransfersightseeingchange,
    transferSightseeingdisable,
    transferSightseeingopen,
    handleTransferSightseeing,
    transferSupplierDetail,
    onChangeDropdown,
    transferSuppliervehicleDetail,
    handleRemoveTransferVehicle,
    // Airport Transfers
    EnableAirportSightseeingInclusionIds,
    airportSightseeinglistdata,
    airportSightseeingDetail,
    airportSightseeingdisable,
    airportSightseeingopen,
    // Hotels
    hotelList,
    hotelnameid,
    handlehotelnamechange,
    hoteldisable,
    hotelopen,
    handleHotel,
    hotelname,
    hotelrating,
    roomtypelist,
    hotelroomtypeid,
    handleRoomTypeChange,
    roomMealList,
    mealTypeId,
    handleMealType,
    // Sightseeing
    EnableSightseeingInclusionIds,
    sightseeingid,
    handlesightseeingchange,
    sightseeingdisable,
    sightseeingopen,
    handleSightseeing,
    sightseeingname,
    hoursTime,
    vehicalistdata,
    vehicaltypeid,
    handlevehicaltype,
    vehicalprice,
    // Attractions
    attractionList,
    handleSelectAttraction,
    InputOption,
    attractionDetailShow,
    setAttractionDetailShow,
    attractionDetail,
    // Actions & Table
    handleitinerary,
    itinerarybtntext,
    ClearItineraryDetail,
    dataitinerary,
    dataitinerarycounter,
    handleEditItinerary,
    removeitinerary
}) => {
    const selectedSightseeing = useMemo(
        () => sightseeinglistdata?.find(list => list?.value === formvalue?.DaySightseeingId) || null,
        [sightseeinglistdata, formvalue?.DaySightseeingId]
    );

    const selectedInclusions = useMemo(() => {
        if (!formvalue?.InclusionId?.length) return [];
        return inclusionwithshortnamelist?.filter(list => formvalue.InclusionId.includes(list?.value)) || [];
    }, [inclusionwithshortnamelist, formvalue?.InclusionId]);

    if (!Shown?.Itinerary) return null;

    const isFlightIncluded = formvalue?.InclusionId?.includes(2);
    const isTransferIncluded = EnableTransferSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele));
    const isAirportTransferIncluded = EnableAirportSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele));
    const isHotelIncluded = formvalue?.InclusionId?.includes(1);
    const isSightseeingIncluded = EnableSightseeingInclusionIds?.some((ele) => formvalue?.InclusionId?.includes(ele));

    return (
        <div className="accordion-item mb-3">
            <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
                <button
                    className="accordion-button collapsed"
                    type="button"
                    id="ItineraryError"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                >
                    Day Schedule
                </button>
            </h2>

            <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                <div className="accordion-body">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <div className="row">
                            {formerror?.ItineraryError && <p className="text-danger text-center">{formerror.ItineraryError}</p>}

                            {/* Sightseeing Name */}
                            <div className="col-lg-12 col-sm-6">
                                <div className="row">
                                    <div className="col-lg-2 col-md-12 mb-1">
                                        <label className="col-form-label required">Sightseeing Name</label>
                                    </div>
                                    <div className="col-lg-4 mb-1 col-md-12">
                                        <Select
                                            name="DaySightseeingId"
                                            inputId="DaySightseeingId"
                                            className="dropdown select_dropdown"
                                            options={sightseeinglistdata}
                                            value={selectedSightseeing}
                                            onChange={handleDaysightseeing}
                                            isDisabled={disabled}
                                            isSearchable
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Enter Day */}
                            <div className="col-lg-12 col-sm-12">
                                <div className="row">
                                    <div className="col-lg-2 col-md-12 mb-1">
                                        <label className="col-form-label required">Enter Day</label>
                                    </div>
                                    <div className="col-lg-10 mb-1 col-md-12">
                                        <textarea
                                            id="inputPassword6"
                                            className="form-control"
                                            name="Day"
                                            value={formvalue?.Day || ''}
                                            onChange={onChange}
                                            disabled={disabled || formvalue?.DaySightseeingId <= 0}
                                            placeholder="Enter Day"
                                        />
                                        {formerror?.ItineraryDayError && <p className="text-danger text-start">{formerror.ItineraryDayError}</p>}
                                    </div>
                                </div>
                            </div>

                            {/* Day Schedule Rich Text */}
                            <div className="col-lg-12 col-sm-12">
                                <div className="row">
                                    <div className="col-lg-2 col-md-3 mb-1">
                                        <label className="col-form-label required">Day Schedule</label>
                                    </div>
                                    <div className="col-lg-10 mb-1 col-md-9 dayschedule">
                                        <RichTextBox
                                            field="DaySchedule_1"
                                            fieldvalue={formvalue?.DaySchedule}
                                            tabIndex={1}
                                            OnChangeofRichBox={(value) => { formvalue.DaySchedule = value; }}
                                            setRef={setEditorRef}
                                            textconfig={dayscheduleconfig}
                                        />
                                        {formerror?.ItineraryDayScheduleError && <p className="text-danger text-start">{formerror.ItineraryDayScheduleError}</p>}
                                    </div>
                                </div>
                            </div>

                            {/* Add Inclusion Dropdown */}
                            <div className="col-lg-12 col-sm-6">
                                <div className="row">
                                    <div className="col-lg-2 col-md-12 mb-1">
                                        <label className="col-form-label">Add Inclusion</label>
                                    </div>
                                    <div className="col-lg-4 mb-1 col-md-12">
                                        <Select
                                            className="dropdown select_dropdown"
                                            options={inclusionwithshortnamelist}
                                            value={selectedInclusions}
                                            onChange={handleinclusionnamechange}
                                            isDisabled={disabled}
                                            isSearchable
                                            isMulti
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={false}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* 1. Flight Inclusion */}
                            <FlightInclusion
                                disabled={disabled}
                                isFlightIncluded={isFlightIncluded}
                                flightvisible={flightvisible}
                                flightopen={flightopen}
                                handleFlight={handleFlight}
                                flightfrom={flightfrom}
                                flightfromid={flightfromid}
                                handleFlightFromchange={handleFlightFromchange}
                                fromflightdisable={fromflightdisable}
                                flightto={flightto}
                                flighttoid={flighttoid}
                                handleFlightToChange={handleFlightToChange}
                                toflightdisable={toflightdisable}
                                formvalue={formvalue}
                                onChange={onChange}
                                airlinelist={airlinelist}
                                airlineid={airlineid}
                                handleAirlineChange={handleAirlineChange}
                                flightnolist={flightnolist}
                                flightno={flightno}
                                handleFlightNoChange={handleFlightNoChange}
                                arrivalTime={arrivalTime}
                                departureTime={departureTime}
                                handleonchangeofTime={handleonchangeofTime}
                                airlineclasslist={airlineclasslist}
                                classid={classid}
                                handleclasschange={handleclasschange}
                                supplierlist={supplierlist}
                                supplierid={supplierid}
                                handlesupplierchange={handlesupplierchange}
                            />

                            {/* 2. Transfers Inclusion */}
                            <TransferInclusion
                                disabled={disabled}
                                isTransferIncluded={isTransferIncluded}
                                transfersightseeinglistdata={transfersightseeinglistdata}
                                transferSightseeingDetail={transferSightseeingDetail}
                                handletransfersightseeingchange={handletransfersightseeingchange}
                                transferSightseeingdisable={transferSightseeingdisable}
                                transferSightseeingopen={transferSightseeingopen}
                                handleTransferSightseeing={handleTransferSightseeing}
                                transferSupplierDetail={transferSupplierDetail}
                                onChangeDropdown={onChangeDropdown}
                                transferSuppliervehicleDetail={transferSuppliervehicleDetail}
                                handleRemoveTransferVehicle={handleRemoveTransferVehicle}
                                formerror={formerror}
                            />

                            {/* 3. Airport Transfers Inclusion */}
                            <AirportTransferInclusion
                                disabled={disabled}
                                isAirportTransferIncluded={isAirportTransferIncluded}
                                airportSightseeinglistdata={airportSightseeinglistdata}
                                airportSightseeingDetail={airportSightseeingDetail}
                                handletransfersightseeingchange={handletransfersightseeingchange}
                                airportSightseeingdisable={airportSightseeingdisable}
                                airportSightseeingopen={airportSightseeingopen}
                                handleTransferSightseeing={handleTransferSightseeing}
                            />

                            {/* 4. Hotel Inclusion */}
                            <HotelInclusion
                                disabled={disabled}
                                isHotelIncluded={isHotelIncluded}
                                hotelList={hotelList}
                                hotelnameid={hotelnameid}
                                handlehotelnamechange={handlehotelnamechange}
                                hoteldisable={hoteldisable}
                                hotelopen={hotelopen}
                                handleHotel={handleHotel}
                                hotelname={hotelname}
                                hotelrating={hotelrating}
                                roomtypelist={roomtypelist}
                                hotelroomtypeid={hotelroomtypeid}
                                handleRoomTypeChange={handleRoomTypeChange}
                                roomMealList={roomMealList}
                                mealTypeId={mealTypeId}
                                handleMealType={handleMealType}
                                formvalue={formvalue}
                                onChange={onChange}
                            />

                            {/* 5. Sightseeing Inclusion */}
                            <SightseeingInclusion
                                disabled={disabled}
                                isSightseeingIncluded={isSightseeingIncluded}
                                sightseeinglistdata={sightseeinglistdata}
                                sightseeingid={sightseeingid}
                                handlesightseeingchange={handlesightseeingchange}
                                sightseeingdisable={sightseeingdisable}
                                sightseeingopen={sightseeingopen}
                                handleSightseeing={handleSightseeing}
                                sightseeingname={sightseeingname}
                                formvalue={formvalue}
                                hoursTime={hoursTime}
                                vehicalistdata={vehicalistdata}
                                vehicaltypeid={vehicaltypeid}
                                handlevehicaltype={handlevehicaltype}
                                vehicalprice={vehicalprice}
                            />

                            {/* 6. Attractions Inclusion */}
                            <AttractionInclusion
                                disabled={disabled}
                                attractionList={attractionList}
                                formvalue={formvalue}
                                handleSelectAttraction={handleSelectAttraction}
                                InputOption={InputOption}
                                attractionDetailShow={attractionDetailShow}
                                setAttractionDetailShow={setAttractionDetailShow}
                                attractionDetail={attractionDetail}
                            />

                            {/* 7. Action Buttons & Itinerary Table */}
                            <ItineraryTable
                                disabled={disabled}
                                handleitinerary={handleitinerary}
                                itinerarybtntext={itinerarybtntext}
                                ClearItineraryDetail={ClearItineraryDetail}
                                dataitinerary={dataitinerary}
                                dataitinerarycounter={dataitinerarycounter}
                                handleEditItinerary={handleEditItinerary}
                                removeitinerary={removeitinerary}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(DayScheduleAccordion);

